const AMC_API_BASE = 'https://api.amctheatres.com/v2'

function isMock() {
  const key = process.env.AMC_API_KEY
  return !key || key === 'mock'
}

// Server-side only - this file should only be imported in API routes
function getApiKey() {
  const key = process.env.AMC_API_KEY
  if (!key) {
    console.warn('[AMC API] AMC_API_KEY environment variable is missing. Operating in MOCK mode.')
    return 'mock'
  }
  return key
}

function getHeaders() {
  return {
    'X-AMC-Vendor-Key': getApiKey(),
    'Content-Type': 'application/json',
  }
}

interface FetchOptions {
  method?: string
  body?: any
}

const MOCK_THEATERS = [
  {
    id: "1001",
    name: "AMC Empire 25",
    location: {
      addressLine1: "234 W 42nd St",
      city: "New York",
      state: "NY",
      postalCode: "10036",
      geoPoint: {
        latitude: 40.7566,
        longitude: -73.9897
      }
    }
  },
  {
    id: "1002",
    name: "AMC Lincoln Square 13",
    location: {
      addressLine1: "1998 Broadway",
      city: "New York",
      state: "NY",
      postalCode: "10023",
      geoPoint: {
        latitude: 40.7745,
        longitude: -73.9818
      }
    }
  },
  {
    id: "1003",
    name: "AMC Kips Bay 15",
    location: {
      addressLine1: "570 2nd Ave",
      city: "New York",
      state: "NY",
      postalCode: "10016",
      geoPoint: {
        latitude: 40.7414,
        longitude: -73.9782
      }
    }
  }
]

const MOCK_MOVIES = [
  {
    id: "101",
    name: "Dune: Part Two",
    genre: "Action/Sci-Fi",
    mpaaRating: "PG-13",
    runTime: 166,
    availableForAList: true,
    media: {
      posterDynamic: "https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&w=400&q=80",
      heroDesktopDynamic: "https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&w=1200&q=80"
    }
  },
  {
    id: "102",
    name: "Oppenheimer",
    genre: "Drama/History",
    mpaaRating: "R",
    runTime: 180,
    availableForAList: true,
    media: {
      posterDynamic: "https://images.unsplash.com/photo-1461360370896-922624d12aa1?auto=format&fit=crop&w=400&q=80",
      heroDesktopDynamic: "https://images.unsplash.com/photo-1461360370896-922624d12aa1?auto=format&fit=crop&w=1200&q=80"
    }
  },
  {
    id: "103",
    name: "Spider-Man: Beyond the Spider-Verse",
    genre: "Animation/Action",
    mpaaRating: "PG",
    runTime: 140,
    availableForAList: true,
    media: {
      posterDynamic: "https://images.unsplash.com/photo-1635805737707-575885ab0820?auto=format&fit=crop&w=400&q=80",
      heroDesktopDynamic: "https://images.unsplash.com/photo-1635805737707-575885ab0820?auto=format&fit=crop&w=1200&q=80"
    }
  },
  {
    id: "104",
    name: "Civil War",
    genre: "Action/Thriller",
    mpaaRating: "R",
    runTime: 109,
    availableForAList: false,
    media: {
      posterDynamic: "https://images.unsplash.com/photo-1533928298208-27ff66555d8d?auto=format&fit=crop&w=400&q=80",
      heroDesktopDynamic: "https://images.unsplash.com/photo-1533928298208-27ff66555d8d?auto=format&fit=crop&w=1200&q=80"
    }
  },
  {
    id: "105",
    name: "Godzilla x Kong: The New Empire",
    genre: "Action/Sci-Fi",
    mpaaRating: "PG-13",
    runTime: 115,
    availableForAList: true,
    media: {
      posterDynamic: "https://images.unsplash.com/photo-1568832359672-e36cf5d74f54?auto=format&fit=crop&w=400&q=80",
      heroDesktopDynamic: "https://images.unsplash.com/photo-1568832359672-e36cf5d74f54?auto=format&fit=crop&w=1200&q=80"
    }
  }
]

function generateMockShowtimes(date: string) {
  const showtimes: any[] = []
  
  const formats = [
    {
      format: 'Standard',
      attributes: [{ code: 'RECLINERS', name: 'Reclining Seats' }]
    },
    {
      format: 'IMAX',
      attributes: [{ code: 'IMAX', name: 'IMAX' }, { code: 'RECLINERS', name: 'Reclining Seats' }]
    },
    {
      format: 'Dolby Cinema',
      attributes: [{ code: 'DOLBY CINEMA', name: 'Dolby Cinema' }, { code: 'DOLBY ATMOS', name: 'Dolby Atmos' }]
    },
    {
      format: '3D',
      attributes: [{ code: '3D', name: 'RealD 3D' }]
    }
  ]

  const times = ['12:30', '15:45', '19:00', '22:15']

  MOCK_THEATERS.forEach(theater => {
    MOCK_MOVIES.forEach(movie => {
      times.forEach((time, index) => {
        const formatObj = formats[index % formats.length]
        const showId = `show_${theater.id}_${movie.id}_${index}`
        
        const localTimeStr = `${date}T${time}:00`
        const utcTimeStr = `${date}T${time}:00Z`

        showtimes.push({
          id: showId,
          showId: showId,
          movieId: movie.id,
          theatreId: theater.id,
          showDateUtc: date,
          showDateTimeLocal: localTimeStr,
          showDateTimeUtc: utcTimeStr,
          movieName: movie.name,
          attributes: formatObj.attributes,
          purchaseUrl: 'https://www.amctheatres.com',
          isSoldOut: false,
          isCanceled: false
        })
      })
    })
  })

  return showtimes
}

function handleMockRequest(endpoint: string, options: FetchOptions = {}) {
  console.log('[AMC API MOCK] Intercepted endpoint:', endpoint)

  if (endpoint.startsWith('/showtimes/views/current-location/')) {
    const parts = endpoint.split('/')
    const date = parts[4]?.split('?')[0] || new Date().toISOString().split('T')[0]
    const showtimes = generateMockShowtimes(date)
    return {
      _embedded: {
        showtimes
      },
      count: showtimes.length,
      pageSize: 100,
      pageNumber: 1
    }
  }

  if (endpoint.startsWith('/movies?')) {
    const urlObj = new URL(`http://localhost${endpoint}`)
    const idsStr = urlObj.searchParams.get('ids')
    const ids = idsStr ? idsStr.split(',') : []
    const movies = MOCK_MOVIES.filter(m => ids.includes(m.id))
    return {
      _embedded: {
        movies
      },
      count: movies.length,
      pageSize: 100,
      pageNumber: 1
    }
  }

  if (endpoint.startsWith('/movies/')) {
    const movieId = endpoint.split('/')[2]?.split('?')[0]
    const movie = MOCK_MOVIES.find(m => m.id === movieId)
    if (!movie) {
      throw new Error(`Mock Movie ${movieId} not found`)
    }
    return movie
  }

  if (endpoint.startsWith('/theatres?')) {
    const urlObj = new URL(`http://localhost${endpoint}`)
    const idsStr = urlObj.searchParams.get('ids')
    const ids = idsStr ? idsStr.split(',') : []
    const theatres = MOCK_THEATERS.filter(t => ids.includes(t.id))
    return {
      _embedded: {
        theatres
      },
      count: theatres.length,
      pageSize: 100,
      pageNumber: 1
    }
  }

  if (endpoint.includes('/showtimes') && endpoint.startsWith('/theatres/')) {
    const parts = endpoint.split('/')
    const theaterId = parts[2]
    const date = new Date().toISOString().split('T')[0]
    const showtimes = generateMockShowtimes(date).filter(s => s.theatreId === theaterId)
    return {
      _embedded: {
        showtimes
      },
      count: showtimes.length,
      pageSize: 100,
      pageNumber: 1
    }
  }

  if (endpoint.startsWith('/theatres/')) {
    const theaterId = endpoint.split('/')[2]?.split('?')[0]
    const theater = MOCK_THEATERS.find(t => t.id === theaterId)
    if (!theater) {
      throw new Error(`Mock Theater ${theaterId} not found`)
    }
    return theater
  }

  return {}
}

async function fetchAMC(endpoint: string, options: FetchOptions = {}) {
  if (isMock()) {
    return handleMockRequest(endpoint, options)
  }

  const url = `${AMC_API_BASE}${endpoint}`

  try {
    const response = await fetch(url, {
      method: options.method || 'GET',
      headers: getHeaders(),
      body: options.body ? JSON.stringify(options.body) : undefined,
    })
    const text = await response.text()

    if (!response.ok) {
      throw new Error(`AMC API error: ${response.status} ${response.statusText} - ${text}`)
    }

    return JSON.parse(text)
  } catch (error) {
    console.error(`[AMC API] Error fetching ${endpoint}:`, error)
    throw error
  }
}

export interface PaginatedResponse<T> {
  data: T[]
  count: number
  pageSize: number
  pageNumber: number
}

export async function getShowtimesByLocation(
  date: string,
  latitude: number,
  longitude: number,
  pageNumber: number = 1,
  pageSize: number = 100
): Promise<PaginatedResponse<any>> {
  const endpoint = `/showtimes/views/current-location/${date}/${latitude}/${longitude}`
  const params = new URLSearchParams({
    'page-number': pageNumber.toString(),
    'page-size': pageSize.toString(),
  })

  const response = await fetchAMC(`${endpoint}?${params}`)
  
  // Response structure: { _embedded: { showtimes: [...] }, count, pageSize, pageNumber }
  return {
    data: response._embedded?.showtimes || [],
    count: response.count || 0,
    pageSize: response.pageSize || pageSize,
    pageNumber: response.pageNumber || pageNumber,
  }
}

// Helper to fetch all pages of showtimes
export async function getAllShowtimesByLocation(
  date: string,
  latitude: number,
  longitude: number,
  pageSize: number = 100
): Promise<any[]> {
  const allShowtimes: any[] = []
  let pageNumber = 1
  let totalFetched = 0
  let totalCount = 0

  do {
    const response = await getShowtimesByLocation(date, latitude, longitude, pageNumber, pageSize)
    allShowtimes.push(...response.data)
    totalFetched += response.data.length
    totalCount = response.count
    pageNumber++
  } while (totalFetched < totalCount)

  return allShowtimes
}

// Fetch movie details by movieId
export async function getMovieDetails(movieId: string): Promise<any> {
  const endpoint = `/movies/${movieId}`
  const response = await fetchAMC(endpoint)
  return response
}

// Fetch multiple movies by IDs with pagination support
export async function getMoviesByIds(movieIds: string[], pageSize: number = 100): Promise<any[]> {
  if (movieIds.length === 0) {
    return []
  }

  const allMovies: any[] = []
  let pageNumber = 1
  let totalFetched = 0
  let totalCount = 0

  do {
    const params = new URLSearchParams({
      ids: movieIds.join(','),
      'page-number': pageNumber.toString(),
      'page-size': pageSize.toString(),
    })

    const endpoint = `/movies?${params}`
    const response = await fetchAMC(endpoint)

    const movies = extractEmbeddedArray(response, 'movies')
    allMovies.push(...movies)
    totalFetched += movies.length
    totalCount = response.count
    pageNumber++
  } while (totalFetched < totalCount && totalCount > 0)

  return allMovies
}

// Fetch multiple theaters by IDs with pagination support
export async function getTheatersByIds(theaterIds: string[], pageSize: number = 100): Promise<any[]> {
  if (theaterIds.length === 0) {
    return []
  }

  const allTheaters: any[] = []
  let pageNumber = 1
  let totalFetched = 0
  let totalCount = 0

  do {
    const params = new URLSearchParams({
      ids: theaterIds.join(','),
      'page-number': pageNumber.toString(),
      'page-size': pageSize.toString(),
    })

    const endpoint = `/theatres?${params}`
    const response = await fetchAMC(endpoint)

    const theaters = extractEmbeddedArray(response, 'theatres')
    allTheaters.push(...theaters)
    totalFetched += theaters.length
    totalCount = response.count
    pageNumber++
  } while (totalFetched < totalCount && totalCount > 0)

  return allTheaters
}

// Fetch all future showtimes for a specific theater
export async function getTheaterScheduledShowtimes(
  theaterId: string,
  pageSize: number = 100
): Promise<any[]> {
  // Fetch first page to get total count
  let firstPageResponse
  try {
    const params = new URLSearchParams({
      'page-number': '1',
      'page-size': pageSize.toString(),
    })
    const endpoint = `/theatres/${theaterId}/showtimes?${params}`
    firstPageResponse = await fetchAMC(endpoint)
  } catch (error) {
    console.error(`[AMC API] Error fetching initial page for theater ${theaterId}:`, error)
    return []
  }

  const firstPageShowtimes = firstPageResponse._embedded?.showtimes || []
  const totalCount = firstPageResponse.count || firstPageShowtimes.length
  
  if (totalCount <= pageSize) {
    return firstPageShowtimes
  }

  const totalPages = Math.ceil(totalCount / pageSize)
  const pageNumbers = Array.from({ length: totalPages - 1 }, (_, i) => i + 2)

  const promises = pageNumbers.map(async (page) => {
    try {
      const params = new URLSearchParams({
        'page-number': page.toString(),
        'page-size': pageSize.toString(),
      })
      const endpoint = `/theatres/${theaterId}/showtimes?${params}`
      const response = await fetchAMC(endpoint)
      return response._embedded?.showtimes || []
    } catch (error) {
      console.error(`[AMC API] Error fetching page ${page} for theater ${theaterId}:`, error)
      return []
    }
  })

  const results = await Promise.all(promises)
  const allShowtimes = [firstPageShowtimes, ...results].flat()
  return allShowtimes
}

// Fetch detailed theater information including coordinates
export async function getTheaterDetails(theaterId: string): Promise<any> {
  const endpoint = `/theatres/${theaterId}`
  const response = await fetchAMC(endpoint)
  return response
}

function extractEmbeddedArray(response: any, key: string): any[] {
  if (!response) return []
  if (Array.isArray(response)) return response
  return response._embedded?.[key] || []
}

// Fetch multiple theater details in one API call
export async function getTheaterDetailsBatch(theaterIds: string[]): Promise<Map<string, any>> {
  if (theaterIds.length === 0) return new Map()

  const idsParam = theaterIds.join(',')
  const endpoint = `/theatres?ids=${idsParam}`
  const response = await fetchAMC(endpoint)

  const theaters = extractEmbeddedArray(response, 'theatres')
  const theaterMap = new Map<string, any>()

  theaters.forEach((theater: any) => {
    if (theater?.id) {
      theaterMap.set(theater.id, theater)
    }
  })

  return theaterMap
}

// Known language names used to split compound attribute codes like "KOREANENGLISHSUBTITLE"
// This is NOT a restrictive filter — unrecognized languages still produce labels via the name field fallback
const KNOWN_LANGUAGES = [
  'ENGLISH', 'SPANISH', 'FRENCH', 'GERMAN', 'ITALIAN', 'PORTUGUESE',
  'HINDI', 'JAPANESE', 'KOREAN', 'MANDARIN', 'CANTONESE', 'CHINESE',
  'TELUGU', 'TAMIL', 'MALAYALAM', 'KANNADA', 'BENGALI', 'MARATHI', 'GUJARATI', 'PUNJABI',
  'ARABIC', 'VIETNAMESE', 'THAI', 'TAGALOG', 'FILIPINO',
  'RUSSIAN', 'POLISH', 'TURKISH', 'PERSIAN', 'HEBREW', 'UKRAINIAN',
]

function titleCase(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

/**
 * Dynamically parse a language/subtitle/dubbed attribute code into a human-readable label.
 * Handles any combination the API sends — no hardcoded map needed.
 */
function parseLanguageAttribute(code: string, name: string): string | undefined {
  const upper = code.toUpperCase()

  // Special case: Open Caption
  if (upper === 'OPENCAPTION' || upper === 'OPEN_CAPTION') return 'Open Caption'

  // Detect subtitle or dubbed suffix
  const isSubtitled = upper.includes('SUBTITLE')
  const isDubbed = upper.includes('DUBBED')
  if (!isSubtitled && !isDubbed) return undefined

  // Strip the action suffix to isolate language portion
  const languagePortion = upper
    .replace(/SUBTITLES?/g, '')
    .replace(/DUBBED/g, '')
    .replace(/[_\s-]/g, '')

  // Find known languages in the portion, ordered by position in the string
  const found: { lang: string; index: number }[] = []
  for (const lang of KNOWN_LANGUAGES) {
    const idx = languagePortion.indexOf(lang)
    if (idx !== -1) {
      found.push({ lang, index: idx })
    }
  }
  found.sort((a, b) => a.index - b.index)
  const foundLanguages = found.map(f => f.lang)

  if (isDubbed) {
    if (foundLanguages.length >= 1) {
      return `${titleCase(foundLanguages[0])} Dubbed`
    }
    // Fallback: use the API-provided name, or generic
    if (name && (name.toLowerCase().includes('dub') || name.toLowerCase().includes('language'))) {
      return name
    }
    return 'Dubbed'
  }

  if (isSubtitled) {
    if (foundLanguages.length === 2) {
      // e.g. KOREANENGLISHSUBTITLE → "Korean w/ English Subtitles"
      return `${titleCase(foundLanguages[0])} w/ ${titleCase(foundLanguages[1])} Subtitles`
    }
    if (foundLanguages.length === 1) {
      // Single language — could be the audio language or subtitle language
      // e.g. SPANISHSUBTITLE → "Spanish Subtitled"
      return `${titleCase(foundLanguages[0])} Subtitled`
    }
    // No recognized languages — use the API name field if available
    if (name && name.trim()) {
      return name.trim()
    }
    return 'Subtitled'
  }

  return undefined
}

export function parseShowtimeAttributes(attributes: any[] = []) {
  const parsed: {
    format?: string
    language?: string
    features: string[]
  } = {
    features: [],
  }

  const codes = new Set(attributes.map(a => a.code?.toUpperCase() || ''))
  const hasIMAX = Array.from(codes).some(c => c.includes('IMAX'))
  const has3D = Array.from(codes).some(c => c.includes('3D') || c.includes('REALD3D'))
  const isIMAX3D = hasIMAX && has3D

  if (isIMAX3D) {
    parsed.format = 'IMAX 3D'
  }

  for (const attr of attributes) {
    const code = attr.code?.toUpperCase() || ''
    const name = attr.name || ''

    // Check for primary formats (mutually exclusive)
    if (isIMAX3D) {
      // already set
    } else if (code.includes('DOLBY') && code.includes('CINEMA')) {
      parsed.format = 'Dolby Cinema'
    } else if (code.includes('IMAX')) {
      parsed.format = 'IMAX'
    } else if (code.includes('SCREENX')) {
      parsed.format = 'ScreenX'
    } else if (code.includes('3D')) {
      parsed.format = '3D'
    } else if (code.includes('70MM')) {
      parsed.format = '70mm'
    } else if (code.includes('PRIME')) {
      parsed.format = 'PRIME'
    } else if (code.includes('BIGD')) {
      parsed.format = 'BigD'
    } else if (code.includes('XL')) {
      parsed.format = 'XL'
    }

    // Dynamically parse language/subtitle/dubbed from attribute code
    if (!parsed.language) {
      const langLabel = parseLanguageAttribute(code, name)
      if (langLabel) {
        parsed.language = langLabel
      }
    }

    // Add other features
    if (
      (code.includes('DOLBY') && code.includes('ATMOS')) ||
      code.includes('LASER') ||
      code.includes('RECLINERS') ||
      code.includes('CLOSEDCAPTION')
    ) {
      parsed.features.push(name)
    }
  }

  return parsed
}

// Utility to extract unique filter options from showtimes
export function extractFilterOptions(showtimes: any[]) {
  const formats = new Set<string>()
  const languages = new Set<string>()
  const features = new Set<string>()

  for (const showtime of showtimes) {
    const parsed = parseShowtimeAttributes(showtime.attributes)

    if (parsed.format) {
      formats.add(parsed.format)
    }
    if (parsed.language) {
      languages.add(parsed.language)
    }
    parsed.features.forEach(f => features.add(f))
  }

  return {
    formats: Array.from(formats).sort(),
    languages: Array.from(languages).sort(),
    features: Array.from(features).sort(),
  }
}

export function getFormatPriority(f: string): number {
  const u = f.toUpperCase()
  if (u.includes('IMAX') && u.includes('3D')) return 1
  if (u.includes('IMAX')) return 2
  if (u.includes('DOLBY') && u.includes('CINEMA')) return 3
  if (u.includes('PRIME')) return 4
  if (u.includes('70MM')) return 5
  if (u.includes('3D') || u.includes('REALD')) return 6
  if (u.includes('SCREENX')) return 7
  if (u.includes('BIGD')) return 8
  if (u.includes('XL')) return 9
  return 100
}

